import { band, average, fmtScore } from "@/lib/heat";

export const OverallInsight = ({ scores, insights, heading = "Overall" }) => {
  const avg = average(scores);
  const b = band(avg);
  const text = insights?.overall?.[b.label];
  return (
    <section
      data-testid="overall-insight"
      className="avoid-break mt-8 rounded-2xl border-l-4 bg-slate-50 p-5 sm:p-6 print:mt-0"
      style={{ borderColor: b.hex }}
    >
      <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
        <span className="text-[10px] font-mono uppercase tracking-widest text-slate-500">{heading}</span>
        <span className="font-display text-2xl font-bold" style={{ color: b.hex }} data-testid="overall-level">{b.label}</span>
        <span className="font-mono text-sm text-slate-500" data-testid="overall-average">average {fmtScore(Math.round(avg * 10) / 10)} / 36 per area</span>
      </div>
      {text && <p className="mt-3 text-sm sm:text-base leading-relaxed text-slate-700" data-testid="overall-insight-text">{text}</p>}
    </section>
  );
};
